import { Card } from '@/components/ui/card';
import { serviceIcon } from './serviceIcons';
import './ServiceCard.css';

export function ServiceCard({
  iconName,
  serviceName,
  description,
  standardPrice,
  requiredHours
}) {
  const Icon = serviceIcon(iconName);

  return (
    <Card className="service-card">
      <div className="service-card__body">
        <div className="service-card__icon">
          <Icon size={24} />
        </div>
        <div className="service-card__content">
          <h3 className="service-card__title">{serviceName}</h3>
          <p className="service-card__description">{description}</p>
          <div className="service-card__meta">
            {standardPrice > 0 ? (
              <span className="service-card__price">from €{standardPrice}</span>
            ) : (
              <span className="service-card__price service-card__price--absent">
                Contact for price
              </span>
            )}
            <span className="service-card__hours">~{requiredHours}h</span>
          </div>
        </div>
      </div>
    </Card>
  );
}
